// @ts-ignore
export const HEADERBFF_URL = `${window.env.API_BASE_URL}/st/platform/header/services`;
// @ts-ignore
export const ONE_ADMIN_URL = `${window.env.ONE_ADMIN_BASE_URL}/admin/dashboard?RedirectToIdentityProvider=`;
